import React, { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import './Navbar.scss';
import gsap from 'gsap';

const NavButton = ({ label, isActive, onClick, isLLMoid }) => {
  return (
    <button
      className={`nav-button ${isActive ? 'active' : ''} ${isLLMoid ? 'llmoid-button' : ''}`}
      onClick={onClick}
    >
      {label}
      {isLLMoid && <span className="star-icon link">✦</span>}
    </button>
  );
};

const Navbar = () => {
  const buttonsRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (!buttonsRef.current) return;

    const tl = gsap.timeline({
      delay: 1,
      onComplete: () => {
        buttonsRef.current?.classList.add('hover-buttons');
      },
      onStart: () => {
        buttonsRef.current?.classList.remove('hover-buttons');
      },
    });

    tl.fromTo(
      [...buttonsRef.current.children],
      {
        opacity: 0,
        scale: 0,
      },
      {
        duration: 0.8,
        opacity: 1,
        scale: 1,
        ease: 'back.out(1.7)',
        stagger: 0.1,
      }
    );
  }, [buttonsRef]);

  const handleNavClick = route => {
    if (location.pathname === route) {
      return;
    }
    navigate(route, { viewTransition: true });
  };

  const navItems = [
    { label: 'Home', path: '/' },
    { label: 'Hello', path: '/hello' },
    { label: 'LLMoid', path: '/llmoid' },
    { label: 'Work', path: '/work' },
    { label: 'Connect', path: '/connect' },
  ];

  return (
    <nav className="navbar" ref={buttonsRef}>
      {navItems.map(item => (
        <NavButton
          key={item.path}
          label={item.label}
          isActive={location.pathname === item.path}
          onClick={() => handleNavClick(item.path)}
          isLLMoid={item.path === '/llmoid'}
        />
      ))}
    </nav>
  );
};

export default Navbar;
